<template>
  <div class="contactUs" :class="{ open: Store.state.contactUsModal.open }">
    <!-- <svgicon name="mail-stamp" /> -->
    <div class="strip strip--bottom"></div>
    <div class="strip strip--top"></div>
    <div class="submitting" v-show="submitting">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <div class="close" @click="toggleContactUsModal()">
      Close
      <svgicon
        class="std-grey relative -top-2"
        name="close"
        width="13"
        height="13"
        title="Close contact form."
      />
    </div>
    <svgicon class="pf-logo" name="pipefish-logo-on-light" width="40" height="40" />
    <div class="contactUsWrap">
      <div class="contactUsForm confirmation" v-show="emailSent">
        <svgicon class="" name="check" width="30" height="30" />
        <div class="heading">Thank you for your message.</div>
      </div>
      <div class="contactUsForm" v-show="!emailSent">
        <svgicon class="std-grey" name="message" width="30" height="30" :fill="true" />
        <div class="heading">What do you have in mind?</div>
        <form @submit.prevent="processForm">
          <div class="formFields">
            <fieldset :class="{ error: errors.indexOf('name') !== -1 }">
              <label for="name" class="required">
                Name
                <div class="inputWrap">
                  <input type="text" name="name" id="name" requried v-model="name" />
                </div>
              </label>
            </fieldset>
            <fieldset :class="{ error: errors.indexOf('email') !== -1 }">
              <label for="email" class="required">
                Email
                <div class="inputWrap">
                  <input type="email" name="email" id="email" requried v-model="email" />
                </div>
              </label>
            </fieldset>
            <fieldset class="full">
              <label for="interests">
                I'm interested in...
                <div class="inputWrap inputWrap--select">
                  <select name="interests" id="interests" v-model="interests">
                    <optgroup label="Service areas"></optgroup>
                    <option
                      v-for="option in Store.services"
                      v-bind:value="option.name"
                      :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                    <optgroup label="Case studies"></optgroup>
                    <option
                      v-for="option in Store.caseStudies"
                      v-bind:value="option.title"
                      :key="option.id"
                    >
                      {{ $utils.stripTags(option.title) }}
                    </option>
                    <optgroup label="Other"></optgroup>
                    <option value="Other">Something else (let us know in your message)</option>
                  </select>
                </div>
              </label>
            </fieldset>
            <fieldset class="full" :class="{ error: errors.indexOf('message') !== -1 }">
              <label for="msg">
                Message
                <div class="inputWrap inputWrap--textarea">
                  <textarea name="msg" rows="1" v-model="msg"></textarea>
                </div>
              </label>
            </fieldset>
            <fieldset class="full">
              <div id="g-recaptcha"></div>
            </fieldset>
          </div>
          <div class="formMessages" id="error-message" v-if="errorMsg">
            <div class="formMessages--error" v-html="errorMsg"></div>
          </div>
          <div class="formButtons">
            <button type="submit" class="submit" :disabled="submitting">Send message</button>
          </div>
          <!-- <pre>
             name: {{ name }}
             email: {{ email }}
             interests: {{ interests }}
             msg: {{ msg }}
             errors: {{ errors }}
          </pre> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* global grecaptcha */
import axios from 'axios';
import '@/components/svg/message-outline';
export default {
  name: 'ContactUs',
  components: {},
  data: function() {
    return {
      // emailSent: false,
      gRec: '',
      captchaValid: false,
      submitting: false
    };
  },
  mounted: function() {
    var vm = this;

    function capCallback(response) {
      vm.gRec = response;
      vm.captchaValid = true;
    }

    // let container = document.getElementById('g-recaptcha');
    let parameters = {
      sitekey: '6Lds7aAUAAAAAGYFrahJAxEsGtRljY0yXRTcxbXg',
      // theme: 'dark',
      callback: capCallback
    };

    // if (this.isProd()) {
    setTimeout(function() {
      if (vm.$utils.isDefined(grecaptcha)) {
        grecaptcha.render('g-recaptcha', parameters);
      }
    }, 600);
    // } else {
    // vm.captchaValid = true;
    // }
  },
  watch: {
    name: function() {
      if (this.errors.indexOf('name') !== -1) {
        this.errors.splice(this.errors.indexOf('name'), 1);
      }
      this.validateForm();
    },
    email: function() {
      if (this.errors.indexOf('email') !== -1) {
        this.errors.splice(this.errors.indexOf('email'), 1);
        this.errors.splice(this.errors.indexOf('phone'), 1);
      }
      this.validateForm();
    },
    phone: function() {
      if (this.errors.indexOf('phone') !== -1) {
        this.errors.splice(this.errors.indexOf('phone'), 1);
        this.errors.splice(this.errors.indexOf('email'), 1);
      }
      this.validateForm();
    }
  },
  computed: {
    modal: {
      get: function() {
        return this.Store.state.contactUsModal;
      },
      set: function() {}
    },
    standardErrorMessage: {
      get: function() {
        return `Oh... awkward. It looks like there was a problem sending your message.
                    Please contact us via
                    <a href="mailto:info@pipefish.com.au?subject=Website contact form link&body=
                    Name: ${this.name} %0A%0A
                    Email: ${this.email} %0A%0A
                    Interests: ${this.$utils.stripTags(this.interests)} %0A%0A
                    Message: ${this.msg}">
                    info@pipefish.com.au</a> while we take a look at it.`;
      },
      set: function() {}
    },
    name: {
      get: function() {
        return this.Store.state.contactUsModal.name;
      },
      set: function(newValue) {
        this.Store.state.contactUsModal.name = newValue;
      }
    },
    email: {
      get: function() {
        return this.Store.state.contactUsModal.email;
      },
      set: function(newValue) {
        this.Store.state.contactUsModal.email = newValue;
      }
    },
    interests: {
      get: function() {
        return this.Store.state.contactUsModal.interests;
      },
      set: function(newValue) {
        this.Store.state.contactUsModal.interests = newValue;
      }
    },
    msg: {
      get: function() {
        return this.Store.state.contactUsModal.msg;
      },
      set: function(newValue) {
        this.Store.state.contactUsModal.msg = newValue;
      }
    },
    errors: {
      get: function() {
        return this.Store.state.contactUsModal.errors;
      },
      set: function(newState) {
        this.Store.state.contactUsModal.errors = newState;
      }
    },
    emailSent: {
      get: function() {
        return this.Store.state.contactUsModal.emailSent;
      },
      set: function(newValue) {
        return (this.Store.state.contactUsModal.emailSent = newValue);
      }
    },
    errorMsg: {
      get: function() {
        return this.Store.state.contactUsModal.errorMsg;
      },
      set: function(newValue) {
        return (this.Store.state.contactUsModal.errorMsg = newValue);
      }
    }
  },
  methods: {
    toggleContactUsModal: function() {
      this.$utils.log(['-----toggleContactUsModal()']);
      if (!this.emailSent) {
        // this.resetCaptcha();
        this.Store.toggleContactUsModal();
        // this.Store.dispatch('toggleContactUsModal');
      } else {
        this.Store.closeContactUsModal();
      }
    },
    validateForm: function() {
      var valid = true;
      if (!this.$utils.isDefined(this.name)) {
        if (this.errors.indexOf('name') === -1) {
          this.errors.push('name');
        }
        valid = false;
      }
      if (!this.$utils.isDefined(this.email)) {
        if (this.errors.indexOf('email') === -1) {
          this.errors.push('email');
        }
        valid = false;
      }
      // if (!this.captchaValid) {
      //   valid = false;
      // }
      return valid;
    },
    processForm: function() {
      var vm = this;
      if (!this.validateForm()) {
        return false;
      }

      vm.submitting = true;

      vm.errorMsg = null;
      var postData = new URLSearchParams();
      postData.append('name', vm.name);
      postData.append('email', vm.email);
      postData.append('msg', vm.msg);
      postData.append('interests', vm.interests);
      postData.append('gRec', vm.gRec);
      var options = {};
      axios
        .post('/.netlify/functions/sendgrid', postData, options)
        .then(function(res) {
          if (res.data.success) {
            vm.confirmation = true;
            vm.emailSent = true;
            vm.submitting = false;
            setTimeout(() => {
              // vm.resetCaptcha();
              vm.Store.resetContactUsData();
              vm.toggleContactUsModal();
              vm.emailSent = false;
              vm.confirmation = false;
            }, 1000);
          } else if (!res.data.success) {
            vm.confirmation = false;
            // vm.resetCaptcha();
            vm.submitting = false;
            vm.errorMsg = vm.standardErrorMessage;
          }
        })
        .catch(function() {
          // this.Store.resetContactUsData();
          // vm.resetCaptcha();
          vm.submitting = false;
          vm.errorMsg = vm.standardErrorMessage;
        });
    },
    resetCaptcha: function() {
      // if (this.isProd()) {
      if (this.$utils.isDefined(grecaptcha)) {
        grecaptcha.reset();
      }
      this.gRec = '';
      this.captchaValid = false;
      // }
    },
    isProd: function() {
      // stage or prod
      return location.hostname.indexOf('pipefish.com.au') !== -1;
    }
  }
};
</script>

<style lang="scss">
.contactUs {
  @include rtp_transition($property: 'transform', $duration: 0.3s);
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.3);
  position: fixed;
  background: rgba(#fff, 1);
  z-index: 900 010;
  max-width: 740px;
  border-radius: 2px;
  transform: translateX(0%) translateY(130%);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  overflow: hidden;
  z-index: 999999;
  &.open {
    transform: translateY(0%);
  }
  @include media('>=750px') {
    top: 40px;
    bottom: 40px;
    left: 50%;
    min-width: 700px;
    transform: translateX(-50%) translateY(130%);
    &.open {
      transform: translateX(-50%) translateY(0%);
    }
  }

  .pf-logo {
    position: absolute;
    // opacity: 0.1;
    // right: -20px;
    // bottom: 10%;
    // transform: rotate(-10deg);
    bottom: 30px;
    right: 20px;
    opacity: 0.9;
    display: none;
    @include media('>320px') {
      width: 40px !important;
      height: 40px !important;
      display: block;
    }
  }

  .submitting {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(#fff, 0.9);
    z-index: 200;
    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 12px;
    font-family: $brand-font-family;
    color: $Grey3;
    vertical-align: middle;
    cursor: pointer;
    z-index: 100;
    @include media('>450px') {
      top: 30px;
    }
    svg {
      display: inline-block;
      vertical-align: middle;
      path,
      g {
        stroke: $Grey3;
      }
    }
    &:hover {
      color: $LogoOrange1;
      svg {
        path,
        g {
          stroke: $LogoOrange1;
        }
      }
    }
  }

  .contactUsWrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    background-image: url(~@/assets/svg/mail-stamp.svg);
    background-repeat: no-repeat;
    background-size: 48%;
    background-position: -9% 13%;

    // background-position: -200px 25%;
    // background-size: 90%;

    // @include media('<medium') {
    //   background-size: 80%;
    // }

    .contactUsForm {
      width: 100%;
      max-width: 740px;
      margin: 0 auto;
      padding: 20px;
      padding-top: 35px;

      // top: 50%;
      // position: absolute;
      // transform: translateY(-50%);

      @include media('>450px') {
        padding: 30px;
      }

      .heading {
        font-family: $brand-font-family;
        color: $Grey5Chicago;

        font-size: 20px;
        line-height: 1em;
        margin: 0;
        padding: 10px 0 10px 0;
        position: relative;
        font-weight: 600;

        @include media('>450px') {
          font-size: 20px;
          line-height: 1em;
          margin: 0;
          padding: 30px 0 20px 38px;
          position: relative;
          font-weight: 600;
        }

        @include media('>450px') {
          font-size: 35px;
          margin: 0 0 10px 0;
          // padding: 33px 0 30px 45px;

          text-align: center;
          padding: 85px 0 30px 0px;
        }
      }

      svg {
        display: none;
        path {
          fill: #ddd;
        }
        @include media('>320px') {
          position: absolute;
          left: 0;
          top: 23px;
          // display: block;
        }
        @include media('>450px') {
          width: 50px !important;
          height: 50px !important;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          display: block;
        }
      }

      &.confirmation {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        svg {
          display: none;
          @include media('>320px') {
            display: block;
          }
          top: 35px;
          width: 70px !important;
          height: 70px !important;
          fill: green !important;
        }
        .heading {
        }
      }

      .formFields {
        $fieldPadding: 5px;

        display: flex;
        flex-wrap: wrap;
        margin-left: 0 - ($fieldPadding * 2);
        margin-right: 0 - ($fieldPadding * 2);

        fieldset {
          display: flex;
          width: 100%;
          // background: #eee;
          padding: 0px 10px;
          margin: 0;
          border: 0;

          @include media('>550px') {
            // padding: 5px 10px;
            width: 50%;
          }

          &.error {
            // border: 1px solid red;
            label {
              color: red;
            }
            .inputWrap {
              border-color: red;
            }
          }

          label {
            font-family: $brand-font-family;
            font-size: 16px;
            display: block;
            width: 100%;
            padding: 0 0 0 0;
            display: block;
            &:active,
            &:focus {
              color: $PriBlueLight;
            }
          }

          &.full {
            width: 100%;
          }

          $inputHeight: 45px;
          .inputWrap {
            background: #fff;
            border-bottom: 1px solid #333;
            // height: $inputHeight;
            padding: 0px;
            margin: 3px 0;
            border: 1px solid #ddd;
            border-radius: 2px;
            clear: left;

            &:active,
            &:focus {
              border-color: $PriBlueLight;
            }
            input,
            select,
            textarea {
              background: #fff;
              border: none;
              font-size: 17px;
              padding: 10px 10px;
              width: 100%;
              border-radius: 0px;
              height: $inputHeight - 5px;
              display: block;
              width: 100%;
              @include media('>450px') {
                height: $inputHeight - 1px;
              }
              &:active,
              &:focus {
                background: #ffee;
              }
            }
            select {
              width: 100%;
              -webkit-appearance: none;
            }
            textarea {
              // margin-bottom: -4px;
              height: $inputHeight * 1.5;
              // min-height: $inputHeight - 1px;
            }
          }
        }
      }

      #g-recaptcha {
        margin: 5px 0;
        @include media('>450px') {
          margin: 10px 0;
        }
        > div {
          margin: 0 auto;
        }
      }

      .formButtons {
        text-align: center;
        button.submit {
          padding: 10px 10px;
          width: 100%;
          margin: 5px auto;
          border: none;
          background: $LogoOrange1;
          color: #fff;
          text-transform: uppercase;
          font-size: 14px;
          font-weight: 600;
          border-radius: 2px;

          &:hover,
          &:focus {
            background: darken($LogoOrange1, 10%);
          }
          &:active {
            background: daken($LogoOrange1, 20%);
          }

          @include media('>450px') {
            padding: 15px 10px;
            width: 200px;
          }
        }
      }

      .formMessages {
        text-align: center;
        border: 1px solid lighten(red, 5%);
        background: lighten(red, 45%);
        color: lighten(red, 20%);
        padding: 10px;
        font-size: 14px;
        line-height: 1.3em;
        border-radius: 2px;
        a {
          color: red;
        }
      }
    }
  }
  .strip {
    position: absolute;
    z-index: 20;
    height: 13px;
    background-color: #fff;
    background-image: url(~@/assets/svg/airmail-strip.svg);
    background-repeat: repeat-x;
    background-size: cover;

    &--top {
      top: -1px;
      left: 0;
      right: 0;
    }
    &--bottom {
      bottom: -1px;
      left: 0;
      right: 0;
      transform: rotateX(180deg);
      background-position: 88% 0;
    }
  }
}
</style>
